import { Component, OnDestroy, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { AppBuilderService } from 'app/forms/services/app-builder/app-builder.service';

@Component({
  selector: 'tog-push-settings-form',
  templateUrl: './push-settings-form.component.html',
  styleUrls: ['./push-settings-form.component.scss']
})
export class PushSettingsFormComponent implements OnDestroy {
  pushSettingsForm: FormGroup;
  formChangeSubscription: Subscription;
  shouldReset: Subscription;

  @Input() allowOneForm: boolean = false;

  constructor(private _fb: FormBuilder,
              private _ab: AppBuilderService) {
    this.pushSettingsForm = _fb.group({
      topic_arn: ['', Validators.required],
      sns_region: ['', Validators.required],
      android_arn: ['', Validators.required],
      ios_arn: ['', Validators.required]
    });
    this.formChangeSubscription = this.pushSettingsForm.valueChanges.subscribe((formValue) => {
      this._ab.updateForm(this.pushSettingsForm, 'push', this.allowOneForm);
    });
    this.shouldReset = this._ab.getReset('push').subscribe(() => {
      let allowanceStatus = this.allowOneForm;
      this.allowOneForm = false;
      this.pushSettingsForm.reset();
      this.allowOneForm = allowanceStatus;
    });
  }

  ngOnDestroy() {
    if (this.formChangeSubscription) this.formChangeSubscription.unsubscribe();
    if (this.shouldReset) this.shouldReset.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /app/src/app/forms/components/push-settings-form/push-settings-form.component.ts